<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <draggable v-model="routes" tag="b-list-group" @end="sortChanged">
            <b-list-group-item v-for="(route, index) in routes" v-bind:key="route.id">
              <endpoint v-if="route.actionType == 'endpoint'" :index="index" :value="route" :extensions="extensions" @update="update"></endpoint>
              <extension v-if="route.actionType == 'extension'" :index="index" :value="route" :extensions="extensions" @update="update"></extension>
              <forward v-if="route.actionType == 'forward'" :index="index" :value="route" @update="update"></forward>
              <group v-if="route.actionType == 'group'" :index="index" :value="route" :groups="groups" @update="update"></group>
              <voicemail v-if="route.actionType == 'voicemail'" :index="index" :value="route" :extensions="extensions" @update="update"></voicemail>
            </b-list-group-item>
          </draggable>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="4">
          <b-form-group>
            <label for="route">Add Route</label>
            <b-input-group>
              <b-select size="sm" id="route" :options="addOptions" v-model="actionType"></b-select>
              <b-btn size="sm" :disabled="actionType === null" variant="primary" @click="addType"><i class="fa fa-plus"></i> Add</b-btn>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import Endpoint from './actionTypes/Endpoint.vue'
import Extension from './actionTypes/Extension.vue'
import Forward from './actionTypes/Forward.vue'
import Group from './actionTypes/Group.vue'
import Voicemail from './actionTypes/Voicemail.vue'

export default {
  components: { Endpoint, Extension, Draggable, Forward, Group, Voicemail },
  name: 'InboundRoutes',
  props: [ 'value', 'numberId' ],
  computed: {
    ...mapGetters({
      account: 'global/account',
      extensions: 'account/extensions'
    })
  },
  data () {
    return {
      groups: [],
      routes: [],
      addOptions: [
        { value: 'extension', text: 'Extension' },
        { value: 'forward', text: 'Forward' },
        { value: 'group', text: 'Group' },
        { value: 'voicemail', text: 'Voicemail' }
      ],
      actionType: null
    }
  },
  methods: {
    addType () {
      const route = {
        id: null,
        numberId: this.numberId,
        actionType: this.actionType,
        actionId: null,
        duration: null,
        useAccountCallerId: 0,
        sort: this.routes.length + 1
      }
      this.routes.push(route)
      this.$emit('sortUpdate', this.routes)
      this.actionType = null
    },
    getGroups () {
      if (this.account) {
        this.$axios.get(`/v1/groups?accountId=${this.account.id}`).then((response) => {
          this.groups = response.data
        }).catch((err) => {
          console.error(err)
        })
      }
    },
    update (type, index, data) {
      this.$emit('routeUpdate', type, index, data)
    },
    async sortChanged () {
      await this.routes.forEach(async (o, index) => {
        if (o.id > 0 && o.sort != (index + 1)) {
          o.sort = (index + 1)
          await this.$axios.put(`/v1/numbers/routes/${o.id}`, o)
        } else {
          o.sort = (index + 1)
        }
      })
      this.$emit('sortUpdate', this.routes)
    }
  },
  created () {
    this.routes = this.value
    this.getGroups()
  },
  watch: {
    value: {
      handler () {
        this.routes = this.value
      }
    },
    account: {
      handler () {
        this.getGroups()
      }
    }
  }
}
</script>
